var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.records,
            border: "",
            size: "mini",
            "element-loading-text": "正在加载中～",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "姓名", prop: "passengerName", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "身份证号",
              prop: "passengerCertificateNumber",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "手机号",
              prop: "passengerMobilePhone",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "性别", prop: "sex", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "年龄", prop: "age", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "户籍地", prop: "address", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "添加日期", prop: "createTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "购票次数", prop: "orderCount", align: "center" },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "right",
            "margin-right": "20px",
            "margin-top": "20px",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.paginationObj.current,
              "page-size": _vm.paginationObj.size,
              background: "",
              layout: "prev, pager, next",
              total: _vm.total,
              size: "mini",
            },
            on: { "current-change": _vm.handleCurrentChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }